<div class="ai-chat-overlay" (click)="close()"></div>
<div class="ai-chat-panel" [style.width.px]="panelWidth()">
    <div class="ai-resize-handle" (mousedown)="startResize($event)"></div>
    <div class="ai-chat-header">
        <div class="d-flex align-items-center gap-2">
            <fa-icon [icon]="['fas', 'wand-magic-sparkles']" class="text-primary"></fa-icon>
            <h5 class="mb-0">AI Assistant</h5>
            <fa-icon
                [icon]="['fas', 'circle-info']"
                class="text-body-secondary"
                style="cursor: help; font-size: 0.9rem"
                [ngbTooltip]="tooltipContent"
                placement="bottom"
                container="body"></fa-icon>
        </div>
        <button type="button" class="btn-close" (click)="close()"></button>
    </div>

    <ng-template #tooltipContent>
        <div style="text-align: left; max-width: 300px">
            <strong>Token Usage & Costs</strong>
            <ul class="mb-2 ps-3" style="font-size: 0.85rem">
                <li>Each AI request consumes tokens and incurs costs</li>
                <li>Longer conversations use more tokens as context grows</li>
                <li>Clear history to start fresh and reduce token usage</li>
                <li>Use specific, concise questions for better efficiency</li>
            </ul>
            <small class="text-light">💡 Start new conversations for unrelated topics</small>

            <small
                class="text-light d-block mt-2"
                [ngbTooltip]="
                    'Total Input Tokens: ' +
                    usageTokens().inputTokens +
                    ', Total Output Tokens: ' +
                    usageTokens().outputTokens
                ">
                <fa-icon [icon]="['fas', 'coins']" class="me-1"></fa-icon>
                {{ usageTokens().totalTokens | number }} tokens used
            </small>
        </div>
    </ng-template>

    <div class="ai-chat-messages" #messagesContainer>
        <div class="ai-chat-shadow"></div>
        <div class="ai-mode-selector-floating">
            <button
                type="button"
                class="ai-funky-btn"
                [class.active]="currentMode() === AiMode.Chat"
                (click)="switchMode(AiMode.Chat)"
                [disabled]="isLoading()">
                <div class="ai-funky-btn-icon">
                    <fa-icon [icon]="['fas', 'comment-dots']"></fa-icon>
                </div>
                <div class="ai-funky-btn-content">
                    <span class="ai-funky-btn-title">Chat</span>
                    <span class="ai-funky-btn-subtitle">General Assistant</span>
                </div>
                <div class="ai-funky-btn-glow"></div>
            </button>
            <button
                type="button"
                class="ai-funky-btn"
                [class.active]="currentMode() === AiMode.Boiler"
                (click)="switchMode(AiMode.Boiler)"
                [disabled]="isLoading()">
                <div class="ai-funky-btn-icon">
                    <fa-icon [icon]="['fas', 'fire']"></fa-icon>
                </div>
                <div class="ai-funky-btn-content">
                    <span class="ai-funky-btn-title">Boiler Copilot</span>
                    <span class="ai-funky-btn-subtitle">Install & Service</span>
                </div>
                <div class="ai-funky-btn-glow"></div>
            </button>
        </div>

        @if (messages().length === 0) {
            <div class="ai-welcome-message">
                <div class="ai-message">
                    <div class="ai-message-avatar">
                        <fa-icon
                            [icon]="[
                                'fas',
                                currentMode() === AiMode.Boiler ? 'fire' : 'wand-magic-sparkles',
                            ]"></fa-icon>
                    </div>
                    <div class="ai-message-content">
                        <div class="ai-message-header">
                            <strong>{{ currentMode() === AiMode.Boiler ? 'Boiler Copilot' : 'AI Assistant' }}</strong>
                        </div>
                        @if (currentMode() === AiMode.Chat) {
                            <markdown [data]="chatWelcomeMessage"></markdown>
                        } @else {
                            <markdown [data]="boilerWelcomeMessage"></markdown>
                        }
                    </div>
                </div>
            </div>

            <div class="ai-empty-state">
                <div class="ai-quick-actions">
                    <p class="text-body-secondary mb-2"><small>Quick Actions:</small></p>
                    <div class="d-grid gap-2">
                        @if (currentMode() === AiMode.Chat) {
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ai-quick-action-btn"
                                (click)="sendQuickPrompt('Get a list of my appointments for today')"
                                [disabled]="isLoading()">
                                <fa-icon [icon]="['fas', 'wand-magic-sparkles']" class="me-1"></fa-icon>
                                List Appointments Today
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ai-quick-action-btn"
                                (click)="sendQuickPrompt('What is the average length of appointments this month?')"
                                [disabled]="isLoading()">
                                <fa-icon [icon]="['fas', 'wand-magic-sparkles']" class="me-1"></fa-icon>
                                Average Appointment Length this month
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ai-quick-action-btn"
                                (click)="sendQuickPrompt('Which staff members do not have an appointment right now?')"
                                [disabled]="isLoading()">
                                <fa-icon [icon]="['fas', 'wand-magic-sparkles']" class="me-1"></fa-icon>
                                Available Staff Right Now
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ai-quick-action-btn"
                                (click)="sendQuickPrompt('Show me appointments scheduled for tomorrow')"
                                [disabled]="isLoading()">
                                <fa-icon [icon]="['fas', 'wand-magic-sparkles']" class="me-1"></fa-icon>
                                Tomorrow's Schedule
                            </button>
                        } @else {
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ai-quick-action-btn"
                                (click)="sendQuickPrompt('What is the flue length of worcester bosch greenstar 4000?')"
                                [disabled]="isLoading()">
                                <fa-icon [icon]="['fas', 'fire']" class="me-1"></fa-icon>
                                Greenstar 4000 Flue Length
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ai-quick-action-btn"
                                (click)="
                                    sendQuickPrompt('What does fault code 228 mean on Worcester Bosch Greenstar 8000?')
                                "
                                [disabled]="isLoading()">
                                <fa-icon [icon]="['fas', 'fire']" class="me-1"></fa-icon>
                                Fault Code 228 Worcester Bosch Greenstar 8000
                            </button>
                            <button
                                type="button"
                                class="btn btn-sm btn-outline-primary ai-quick-action-btn"
                                (click)="
                                    sendQuickPrompt('How do I set the \'Supply MIN Set-point\' on a Navien NCB300??')
                                "
                                [disabled]="isLoading()">
                                <fa-icon [icon]="['fas', 'fire']" class="me-1"></fa-icon>
                                Set Supply MIN on Navien NCB300
                            </button>
                        }
                    </div>
                </div>
            </div>
        } @else {
            @for (message of messages(); track message.id) {
                <div class="ai-message" [class.ai-message-user]="message.isUser">
                    <div class="ai-message-avatar">
                        @if (!message.isUser) {
                            <fa-icon [icon]="['fas', message.isUser ? 'user' : 'wand-magic-sparkles']"></fa-icon>
                        } @else {
                            <img [src]="me()?.picture" class="img-fluid rounded-circle" />
                        }
                    </div>
                    <div class="ai-message-content">
                        <div class="ai-message-header">
                            <strong>{{ message.isUser ? 'You' : 'AI Assistant' }}</strong>
                            <small class="text-body-secondary">{{ message.timestamp | date: 'short' }}</small>
                        </div>
                        @if (message.isUser) {
                            <p class="mb-0" style="white-space: pre-wrap">{{ message.content }}</p>
                        } @else {
                            <markdown [data]="message.content"></markdown>
                        }
                    </div>
                </div>
            }
        }
        @if (isLoading()) {
            <div class="ai-message">
                <div class="ai-message-avatar">
                    <fa-icon [icon]="['fas', 'wand-magic-sparkles']"></fa-icon>
                </div>
                <div class="ai-message-content">
                    <div class="ai-typing-indicator">
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </div>
        }
    </div>

    <div class="ai-chat-input">
        @if (messages().length > 10) {
            <p class="small text-danger">
                This chat has more than 10 messages. <br />Consider clearing the chat history to improve performance.
            </p>
        }
        <div class="hstack gap-2">
            <div>
                <button
                    sfButton
                    type="button"
                    [tooltip]="'Clear Chat History and Start Fresh'"
                    [color]="messages().length > 10 ? 'warning' : 'primary'"
                    icon="edit"
                    [disabled]="messages().length === 0 || isLoading()"
                    (click)="clearHistory()"></button>
            </div>
            <div class="flex-grow-1">
                <form (ngSubmit)="sendPrompt()" class="d-flex gap-2">
                    <input
                        type="text"
                        class="form-control"
                        placeholder="Ask me anything..."
                        [formControl]="promptControl"
                        [disabled]="isLoading()" />
                    <button
                        sfButton
                        type="submit"
                        color="primary"
                        icon="paper-plane"
                        [disabled]="promptControl.invalid || isLoading()">
                        Send
                    </button>
                </form>
            </div>
        </div>
    </div>
</div>
